
import httpAES from './http.js'
import auth from './auth.js'
import cacheData from './cacheData'
import mqTTClient from './mqTTClient'
import { newGuid, webBrowser } from '../common'
import { copyTextDirective } from '../common/customDir'
import {global} from './global'
class EventBus {
	constructor() {
		this.events = {};
	}

	on(event, callback) {
		this.events[event] = this.events[event] || [];
		this.events[event].push(callback);
	}

	emit(event, payload) {
		(this.events[event] || []).forEach(callback => callback(payload));
	}

	off(event, callback){
		if(callback){
			let index=(this.events[event]||[]).findIndex(it=>it==callback);
			if(index>=0){
				this.events[event].splice(index,1);
			}
		}else{
			delete this.events[event];
		}
	}
}
//键盘是否可用
const keyavail=true;

//添加复制功能判断
function copyMessageBox(_MessageBox){
	const message=(key)=>{
		return (...args)=>{
			let options={};
			if (typeof args[0] === 'object') {
				options = args[0];
			}else if(typeof args[1] === 'object'){
				options = args[0];
			}else if(typeof args[2] === 'object'){
				options = args[2];
			}
			if(options){
				let className="message_"+Date.now();
				options.customClass=className+" "+(options.customClass||"");
				setTimeout(() => {
					
					// 弹窗  可复制内容区域
					const copyBox = document.querySelector(`.${className} .el-message-box__message`);  
					if (copyBox) {
						// 手动应用指令的效果
						copyTextDirective.copyText(copyBox);
					}
				},0)
			}
			if(key){
				return _MessageBox[key](...args);
			}
			return _MessageBox(...args);
		}
	}
	const messageBox=message();
	['alert', 'confirm', 'prompt'].forEach(type => {
		messageBox[type] = message(type);
	});
	messageBox.close = _MessageBox.close;
	return messageBox;
}

function copyMessage(_Message){
	const message=(options)=>{
		if(options){
			let className="message_"+Date.now();
			options.customClass=className+" "+(options.customClass||"");
			setTimeout(() => {
				
				// 弹窗  可复制内容区域
				const copyBox = document.querySelector(`.${className} .el-message__content`);  
				if (copyBox) {
					// 手动应用指令的效果
					copyTextDirective.copyText(copyBox);
				}
			},0)
		}
		return _Message(options);
	}
	['success', 'warning', 'info', 'error'].forEach(type => {
		message[type] = options => {
			if (typeof options === 'string') {
				options = {
					message: options,
					type,
				};
			}
			else {
				options.type = type;
			}
			return message(options);
		};
	});
	message.closeAll = _Message.closeAll;
	return message;
}

export {
	httpAES,
	auth,
	cacheData,
	mqTTClient,
	global
}

export default {
	install(Vue){
		//全局el提示框 加入点击复制功能
		const _MessageBox = Vue.config.globalProperties.$messageBox;
		const messageBox=copyMessageBox(_MessageBox);
		Vue.config.globalProperties.$msgbox=messageBox;
		Vue.config.globalProperties.$messageBox=messageBox;
		Vue.config.globalProperties.$alert=messageBox.alert;
		Vue.config.globalProperties.$confirm=messageBox.confirm;
		Vue.config.globalProperties.$prompt=messageBox.prompt;

		const _Message=Vue.config.globalProperties.$message;
		Vue.config.globalProperties.$message=copyMessage(_Message);


		// 添加全局对象
		Vue.config.globalProperties.$httpAES = httpAES;
		Vue.config.globalProperties.$auth = auth;
		Vue.config.globalProperties.$cacheData=cacheData;
		Vue.config.globalProperties.$mqTTClient=mqTTClient;
		Vue.config.globalProperties.$global=global;
		Vue.config.globalProperties.$keyavail=keyavail;

		//调用父级的方法 适用于弹出层中调用
		Vue.config.globalProperties.$parentEmit=function(methodName, ...args){
			try{
				let parent=this.$parent;
				if(parent && methodName){
					//父级在弹层中 向上在找
					if(parent?.$?.type?.name=="modalLoad"){
						parent=parent.$parent;
					}
					if(parent?.$?.type?.name=="modalList"){
						parent=parent.$parent;
					}
					if(typeof(parent[methodName])=="function"){
						parent[methodName](...args);
					}
				}
			}catch(e){
				console.error(e);
			}
		}

		Vue.config.globalProperties.$keyBoard={
			show(){},
			close(){}
		}
		Vue.config.globalProperties.$EventBus=new EventBus();
		
		Vue.config.globalProperties.$checkUser={
			/**
			 * 验证用户
			 * @param title 提示内容
			 * @param param 参数
			 */
			show(title,param){}
		};
	}
}